import {
  parseEntityRef,
  RELATION_MEMBER_OF,
  stringifyEntityRef,
  UserEntity,
} from '@backstage/catalog-model';
import {
  catalogApiRef,
  getEntityRelations,
} from '@backstage/plugin-catalog-react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';

export const useOwnedGroups = () => {
  const catalogApi = useApi(catalogApiRef);
  const identityApi = useApi(identityApiRef);

  const [user, setUser] = useState<UserEntity | undefined>(undefined);
  const [userGroups, setUserGroups] = useState<string[] | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchUserAndGroups = async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        if (!identity) {
          return;
        }

        const userRef = parseEntityRef(identity.userEntityRef);

        const fetchedUser = (await catalogApi.getEntityByRef({
          kind: 'User',
          namespace: userRef.namespace ?? 'default',
          name: userRef.name,
        })) as UserEntity;

        setUser(fetchedUser);

        if (fetchedUser) {
          const groups = getEntityRelations(
            fetchedUser,
            RELATION_MEMBER_OF,
          ).map(entityRef => stringifyEntityRef(entityRef));
          setUserGroups(groups);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching user and groups:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndGroups();
  }, [catalogApi, identityApi]);

  return { user, userGroups, loading };
};
